module.exports = __webpack_public_path__ + "files/d1934c67daca6fdc9d3b6c3b8917751b.png";